import { render, staticRenderFns } from "./PolizasIEMovimientos.vue?vue&type=template&id=8fce7b40&"
import script from "./PolizasIEMovimientos.vue?vue&type=script&lang=js&"
export * from "./PolizasIEMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports